// eslint-disable-next-line
export const getModalInfo = (state) => state?.modals?.modalInfo;
